module.exports = __webpack_public_path__ + "static/media/KNI_2026_PDF.6a3a9ad8.pdf";